<template>
  <div class="page">
    <div class="page-title">Pricing</div>
    <double-pane :paneState="paneState">
      <template v-slot:left-pane>
        <div class="left">
          <loading-panel :loading="loading" class="m-auto">
            <button
              class="btn w-100"
              :class="!selected ? 'btn-primary' : 'btn-outline-primary'"
              @click="onSelect(null)"
            >
              Base Pricing
            </button>
            <hr />
            <h4 class="text-center">Companies</h4>
            <div class="my-3 input-group">
              <div class="input-group-prepend">
                <span class="input-group-text" id="filter">
                  <i class="fa fa-search"></i>
                </span>
              </div>
              <input
                v-model.trim="filter"
                @keyup="applyFilter()"
                class="form-control"
                aria-describedby="filter"
                placeholder="filter by name"
              />
            </div>
            <div
              v-for="(company, ind) in filteredCompanies"
              :key="`${ind}_loc`"
            >
              <button
                class="btn w-100 mt-2"
                :class="
                  company === selected ? 'btn-primary' : 'btn-outline-primary'
                "
                @click="onSelect(company)"
              >
                {{ company.name }}
              </button>
            </div>
          </loading-panel>
          <error-panel class="m-auto" :errors="errors"></error-panel>
        </div>
      </template>
      <template v-slot:right-pane>
        <div class="right">
          <loading-panel :loading="loading" class="m-auto">
            <pricing
              :key="basePricing.panel"
              :company="selected"
              :basePricing="basePricing"
            ></pricing>
          </loading-panel>
        </div>
      </template>
      <template v-slot:back-button>
        <button class="btn back-btn" @click.prevent="paneState = 0">
          <i class="material-icons">navigate_before</i>
          <div>Back</div>
        </button>
      </template>
    </double-pane>
  </div>
</template>

<script>
import Pricing from "@/components/Pricing";
import DoublePane from "@/layouts/DoublePane";

export default {
  name: "companies",
  components: {
    DoublePane,
    Pricing,
  },
  data: () => ({
    loading: true,
    errors: [],
    filteredCompanies: [],
    companies: [],
    selected: null,
    filter: "",
    basePricing: {},
    paneState: 0,
  }),
  methods: {
    onSelect(company) {
      this.selected = company;
      this.paneState = 1;
    },
    applyFilter() {
      this.filteredCompanies = this.companies.filter((company) =>
        company.name.toLowerCase().includes(this.filter.toLowerCase())
      );
    },
  },
  async mounted() {
    try {
      this.loading = true;
      const response = await this.$web.getPricing();
      if (response.data.companies && response.data.companies.length > 0) {
        this.companies = response.data.companies;
        this.basePricing = !!response.data.basePricing
          ? response.data.basePricing
          : {};

        this.companies.forEach(
          (company) =>
            (company.pricing = !!company.pricing ? company.pricing : {})
        );
        this.applyFilter();
      } else {
        this.errors = ["No companies found."];
      }
    } catch (err) {
      console.log(err);
      this.errors = ["An error occurred."];
    } finally {
      this.loading = false;
    }
  },
};
</script>

<style scoped>
.logo {
  max-width: 100%;
  max-height: 100%;
}

.left,
.right {
  padding: 20px;
}
</style>
